import { useEffect, useMemo, useState } from "react";
import { Backdrop, Button, LinearProgress } from "@mui/material";
import Box from "@mui/material/Box";
import { FadeIn } from "./fade-in.jsx";

function formatDuration(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

export function FullscreenDownloadProgress({ progress, totalTimeS, onCancel, title }) {
  const [tick, setTick] = useState(0);
  const [progressInternal, setProgressInternal] = useState(0);
  const startTime = useMemo(() => Date.now(), []);

  useEffect(() => {
    if (progress !== undefined) return;
    const token = setInterval(() => setTick(x => x + 1), 1000 / 30);
    return function cleanUp() {
      clearInterval(token);
    };
  }, [progress]);

  const elapsedTimeS = (Date.now() - startTime) / 1000;
  useEffect(() => {
    if (progress !== undefined) return;
    const elapsedTimeS = (Date.now() - startTime) / 1000;
    let p = Math.min(Math.max(elapsedTimeS / totalTimeS, 0), 1);
    // show progressInternal from 10% to 90%
    p = p * 0.8 + 0.1;
    p *= 100;
    setProgressInternal(p);
  }, [totalTimeS, tick, progress]);

  const displayProgress = progress !== undefined ? progress : progressInternal;

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2 }}>
          <div>{title}</div>
          <LinearProgress sx={{ width: 300 }} variant="determinate" value={displayProgress}/>
          <div>{Math.floor(displayProgress)}%</div>
          {progress === undefined && <FadeIn delay={5000}>
            <div>Hátravan: {formatDuration(Math.max(0, Math.ceil(totalTimeS - elapsedTimeS)))}</div>
          </FadeIn>}
        </Box>
        <Button variant={"contained"} onClick={onCancel}>Mégse</Button>
      </Box>
    </Backdrop>
  );
}
